// Canonical origin used for all stable @id / url values in structured data.
// Kept as ninacapone.com regardless of hosting domain so entity @ids stay stable.
export const SITE_ORIGIN = "https://ninacapone.com";

// Stable @id values that live in the global @graph (public/index.html).
export const WEBSITE_ID = `${SITE_ORIGIN}/#website`;
export const PERSON_ID = `${SITE_ORIGIN}/#nina`;
export const ALBUM_AUDIO_PORN_ID = `${SITE_ORIGIN}/#album-audio-porn`;
export const ALBUM_OVA40_ID = `${SITE_ORIGIN}/#album-ova-40`;
export const PODCAST_RTH_ID = `${SITE_ORIGIN}/#podcast-respect-the-hustle`;
export const PODCAST_10MOT_ID = `${SITE_ORIGIN}/#podcast-10-minutes-of-talk`;
export const ORG_INSPIRE_ID = `${SITE_ORIGIN}/#inspiredastreets`;
export const ORG_RADIO_ID = `${SITE_ORIGIN}/#indastreetsradio`;
export const ORG_MYBIZ_ID = `${SITE_ORIGIN}/#mybizconsulting`;

const HOME = ["Home", "/"];

// path -> per-page metadata. `about` references entities in the global graph.
const PAGE_META = {
  "/": {
    name: "Nina Capone | Philadelphia Recording Artist, Performer & Media Personality",
    crumbs: [HOME],
    about: [{ "@id": PERSON_ID }],
    mainEntity: { "@id": PERSON_ID },
  },
  "/music": {
    name: "Music — Nina Capone",
    crumbs: [HOME, ["Music", "/music"]],
    about: [{ "@id": ALBUM_AUDIO_PORN_ID }, { "@id": ALBUM_OVA40_ID }],
  },
  "/radio": {
    name: "Podcast — Nina Capone",
    crumbs: [HOME, ["Podcast", "/radio"]],
    about: [{ "@id": PODCAST_RTH_ID }, { "@id": PODCAST_10MOT_ID }],
  },
  "/inspire": {
    name: "Inspire Da Streets — Nina Capone",
    crumbs: [HOME, ["Inspire Da Streets", "/inspire"]],
    about: [{ "@id": ORG_INSPIRE_ID }],
  },
  "/chronicles": {
    name: "The Mob Mistress Chronicles — Nina Capone",
    crumbs: [HOME, ["The Mob Mistress Chronicles", "/chronicles"]],
    about: [{ "@id": PERSON_ID }],
  },
  "/shop": {
    name: "Shop — Nina Capone",
    crumbs: [HOME, ["Shop", "/shop"]],
    about: [{ "@id": PERSON_ID }],
  },
  "/epk": {
    name: "EPK & Booking — Nina Capone",
    crumbs: [HOME, ["EPK & Booking", "/epk"]],
    about: [{ "@id": PERSON_ID }, { "@id": ORG_MYBIZ_ID }],
  },
  "/about": {
    name: "About Nina Capone — Biography, Discography, Press & Booking",
    crumbs: [HOME, ["About", "/about"]],
    about: [{ "@id": PERSON_ID }],
    mainEntity: { "@id": PERSON_ID },
  },
  "/press": {
    name: "Press & Recognition — Nina Capone Featured In",
    crumbs: [HOME, ["Press", "/press"]],
    about: [{ "@id": PERSON_ID }],
    mainEntity: { "@id": PERSON_ID },
  },
  "/fan-club": {
    name: "Fan Club — Nina Capone",
    crumbs: [HOME, ["Fan Club", "/fan-club"]],
    about: [{ "@id": PERSON_ID }],
  },
  "/backstage": {
    name: "Backstage — Nina Capone",
    crumbs: [HOME, ["Backstage", "/backstage"]],
    about: [{ "@id": PERSON_ID }],
  },
  "/terms": { name: "Terms of Service — Nina Capone", crumbs: [HOME, ["Terms", "/terms"]] },
  "/privacy": { name: "Privacy Policy — Nina Capone", crumbs: [HOME, ["Privacy", "/privacy"]] },
  "/refund": { name: "Refund Policy — Nina Capone", crumbs: [HOME, ["Refund", "/refund"]] },
};

// Resolve metadata for a pathname, including dynamic routes.
export function resolveMeta(pathname) {
  if (PAGE_META[pathname]) return PAGE_META[pathname];

  if (pathname.startsWith("/blog/")) {
    return {
      name: "Inspire Da Streets — Wellness Blog · Nina Capone",
      crumbs: [HOME, ["Inspire Da Streets", "/inspire"], ["Article", pathname]],
      about: [{ "@id": ORG_INSPIRE_ID }],
    };
  }
  if (pathname.startsWith("/chronicles/")) {
    return {
      name: "The Mob Mistress Chronicles — Nina Capone",
      crumbs: [HOME, ["The Mob Mistress Chronicles", "/chronicles"], ["Episode", pathname]],
      about: [{ "@id": PERSON_ID }],
    };
  }
  return { name: "Nina Capone", crumbs: [HOME] };
}
